import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IProductDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GetSelectCustomer: any[];
  GetSelectCustomer_dummy: any[];
  GetProductDetail: any[];
  GetProductDetail_dummy: any[];
  isComp784509Visible: "visible" | "hidden";
  isComp749094Visible: "visible" | "hidden";
  isComp747801Visible: "visible" | "hidden";
  isComp71852Visible: "visible" | "hidden";
  isComp987130Visible: "visible" | "hidden";
  isComp723349Visible: "visible" | "hidden";
  isComp869547Visible: "visible" | "hidden";
  isComp475716Visible: "visible" | "hidden";
  isComp63661Visible: "visible" | "hidden";
}

export class ProductDetail_ScreenBase extends React.PureComponent<
  IProductDetail_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  productdetail_743712_value_kuikaTableRef: React.RefObject<any>;
  productdetail_829675_value_kuikaSelectBoxRef: React.RefObject<any>;
  productdetail_461837_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "a941ffca-925b-4c27-b08b-95c370758eaf",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 574228, PropertyName: "value", Value: "Bırak" },
        { Id: 747801, PropertyName: "value", Value: "Stokta" },
        { Id: 71852, PropertyName: "value", Value: "Stokta Yok" },
        { Id: 987130, PropertyName: "value", Value: "₺2.999,90" },
        { Id: 723349, PropertyName: "value", Value: "₺600,00 tasarruf" },
        { Id: 914807, PropertyName: "value", Value: "Mağaza Stoğu" },
        { Id: 205593, PropertyName: "value", Value: "adet" },
        { Id: 957391, PropertyName: "value", Value: "Genel Stok" },
        { Id: 450330, PropertyName: "value", Value: "adet" },
        { Id: 613499, PropertyName: "value", Value: "Detayları Gör" },
        { Id: 860351, PropertyName: "value", Value: "Kampanyalar" },
        { Id: 658971, PropertyName: "title", Value: "Title" },
        { Id: 120341, PropertyName: "value", Value: "Ürüne %20 İndirim" },
        { Id: 208483, PropertyName: "value", Value: "Aktif" },
        {
          Id: 202347,
          PropertyName: "value",
          Value: "Tüm ürünlerde geçerli %20 indirim kampanyası",
        },
        { Id: 672785, PropertyName: "value", Value: "Uygulanabilir" },
        {
          Id: 656284,
          PropertyName: "value",
          Value: "Bu kampanya sepetinize uygulanabilir",
        },
        { Id: 484091, PropertyName: "value", Value: "Sipariş Detayları" },
        { Id: 189521, PropertyName: "value", Value: "Adet" },
        { Id: 282446, PropertyName: "label", Value: "-" },
        { Id: 762574, PropertyName: "placeholder", Value: "15" },
        { Id: 804415, PropertyName: "value", Value: "Ödeme Planı" },
        { Id: 829675, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 685004, PropertyName: "value", Value: "Açıklama" },
        { Id: 300752, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 248397, PropertyName: "value", Value: "Tahmini Teslim Tarihi" },
        { Id: 461837, PropertyName: "placeholder", Value: "Select Date..." },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productdetail_743712_value_kuikaTableRef = React.createRef();
    this.productdetail_829675_value_kuikaSelectBoxRef = React.createRef();
    this.productdetail_461837_value_kuikaDateRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      GetSelectCustomer: [],
      GetProductDetail: [],
      isComp784509Visible: "hidden",
      isComp749094Visible: "hidden",
      isComp747801Visible: "hidden",
      isComp71852Visible: "hidden",
      isComp987130Visible: "hidden",
      isComp723349Visible: "hidden",
      isComp869547Visible: "hidden",
      isComp475716Visible: "hidden",
      isComp63661Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productdetail",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProductDetailPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.ProductDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productdetail",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productdetail",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProductDetailPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProductDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      productdetail_762574_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProductDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      KUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      ItemCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ItemCode ?? this.props.screenInputs.itemcode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductDetail/ProductDetailPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSelectCustomer = result?.data.getSelectCustomer;
    formVars.productdetail_647019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].curAccCode
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].curAccCode
        : null
    );
    formVars.productdetail_879080_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerName
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerName
        : null
    );
    formVars.productdetail_733290_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerPhone
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerPhone
        : null
    );
    stateVars.isComp784509Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSelectCustomer !== undefined
            ? stateVars.GetSelectCustomer?.length > 0
              ? stateVars.GetSelectCustomer[0].cartHeaderId
              : null
            : this.state.GetSelectCustomer?.length > 0
            ? this.state.GetSelectCustomer[0].cartHeaderId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetProductDetail = result?.data.getProductDetail;
    formVars.productdetail_406688_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].itemDescription
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].itemDescription
        : null
    );
    formVars.productdetail_267903_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].itemCode
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].itemCode
        : null
    );
    formVars.productdetail_871889_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].price1
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].price1
        : null
    );
    formVars.productdetail_565544_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].storeStock
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].storeStock
        : null
    );
    formVars.productdetail_63340_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].totalStock
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].totalStock
        : null
    );
    stateVars.isComp747801Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetProductDetail !== undefined
            ? stateVars.GetProductDetail?.length > 0
              ? stateVars.GetProductDetail[0].hasStock
              : null
            : this.state.GetProductDetail?.length > 0
            ? this.state.GetProductDetail[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp71852Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetProductDetail !== undefined
            ? stateVars.GetProductDetail?.length > 0
              ? stateVars.GetProductDetail[0].hasStock
              : null
            : this.state.GetProductDetail?.length > 0
            ? this.state.GetProductDetail[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductDetailPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp784509Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSelectCustomer !== undefined
            ? stateVars.GetSelectCustomer?.length > 0
              ? stateVars.GetSelectCustomer[0].cartHeaderId
              : null
            : this.state.GetSelectCustomer?.length > 0
            ? this.state.GetSelectCustomer[0].cartHeaderId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productdetail_647019_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].curAccCode
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].curAccCode
        : null
    );

    formVars.productdetail_879080_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerName
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerName
        : null
    );

    formVars.productdetail_733290_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerPhone
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerPhone
        : null
    );

    formVars.productdetail_406688_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].itemDescription
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].itemDescription
        : null
    );

    formVars.productdetail_267903_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].itemCode
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].itemCode
        : null
    );

    stateVars.isComp747801Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetProductDetail !== undefined
            ? stateVars.GetProductDetail?.length > 0
              ? stateVars.GetProductDetail[0].hasStock
              : null
            : this.state.GetProductDetail?.length > 0
            ? this.state.GetProductDetail[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp71852Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetProductDetail !== undefined
            ? stateVars.GetProductDetail?.length > 0
              ? stateVars.GetProductDetail[0].hasStock
              : null
            : this.state.GetProductDetail?.length > 0
            ? this.state.GetProductDetail[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productdetail_871889_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].price1
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].price1
        : null
    );

    formVars.productdetail_565544_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].storeStock
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].storeStock
        : null
    );

    formVars.productdetail_63340_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductDetail !== undefined
        ? stateVars.GetProductDetail?.length > 0
          ? stateVars.GetProductDetail[0].totalStock
          : null
        : this.state.GetProductDetail?.length > 0
        ? this.state.GetProductDetail[0].totalStock
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProductDetailComponent_880267_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductDetailComponent_149994_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/customerselect") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductDetail",
      "CustomerSelect",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProductDetailPageInit();
    }
  }
}
